export default __webpack_public_path__ + "static/media/sticker-I.236db586.png";